<template>
    <div class="partner-nav">
        <div class="partner-nav__container">
            <a
                class="partner-nav__logo"
                aria-label="RTL News"
                href="https://www.rtl.de/"
            >
                <svg
                    viewBox="0 0 91 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g id="RTL Logo" clip-path="url(#clip0_4397_17229)">
                        <g id="RTL Logo_2">
                            <g id="Group">
                                <path
                                    id="Vector"
                                    d="M91.3623 0H62.9082V16H91.3623V0Z"
                                    fill="#EC33EC"
                                ></path>
                                <path
                                    id="Vector_2"
                                    d="M71.751 3.67773H73.7263V10.6169H82.5191V12.3211H71.751V3.67773Z"
                                    fill="white"
                                ></path>
                            </g>
                            <g id="middle">
                                <path
                                    id="Vector_3"
                                    d="M59.9082 0H31.4541V16H59.9082V0Z"
                                    fill="#6F0BED"
                                ></path>
                                <path
                                    id="Vector_4"
                                    d="M44.6916 5.38191H39.6909V3.67773H51.6696V5.38191H46.6689V12.3231H44.6916V5.38191Z"
                                    fill="white"
                                ></path>
                            </g>
                            <g id="Group_2">
                                <path
                                    id="Vector_5"
                                    d="M28.4541 0H0V16H28.4541V0Z"
                                    fill="#2A08B5"
                                ></path>
                                <path
                                    id="Vector_6"
                                    d="M16.3295 9.56782L19.0021 11.8231H17.7035L14.3494 8.92004L14.2085 8.79811H14.0222H10.0574H9.5574V9.29811V11.8231H8.58203V4.17773H15.6643C16.7523 4.17773 17.5269 4.42329 18.0187 4.80798C18.4935 5.17936 18.7577 5.72098 18.7577 6.4558C18.7577 7.0892 18.5563 7.58431 18.2093 7.9471C17.8578 8.31463 17.3189 8.58523 16.5812 8.69073L15.4773 8.84862L16.3295 9.56782ZM14.9053 8.17623V8.17824H15.4053C16.0538 8.17824 16.6253 8.07644 17.0472 7.79705C17.5071 7.49253 17.7201 7.02472 17.7201 6.47989C17.7201 5.93425 17.5063 5.46811 17.0443 5.16684C16.6224 4.89168 16.0515 4.79359 15.4053 4.79359H10.0574H9.5574V5.29359V7.67623V8.17623H10.0574H14.9053Z"
                                    fill="white"
                                    stroke="white"
                                ></path>
                            </g>
                        </g>
                    </g>
                    <defs>
                        <clipPath id="clip0_4397_17229">
                            <rect width="90.85" height="16" fill="white"></rect>
                        </clipPath>
                    </defs></svg
            ></a>
            <div class="partner-nav__text">Medienkooperation</div>
        </div>
    </div>
</template>
<script>
export default {};
</script>
<style scoped lang="scss">
@import '@/sass/mixins';

.partner-nav {
    background-color: white;

    &__container {
        height: 100%;
        margin: auto;
        max-width: 1280px;
        padding: 0 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        @include mq('tablet') {
            padding: 0 32px;
        }
    }

    &__logo {
        cursor: pointer;

        svg {
            max-width: 160px;
            min-width: 100px;
            min-height: 60px;
        }
    }

    &__text {
        font-size: 0.75rem;
        line-height: 1rem;
        color: rgb(107 114 128);
    }
}
</style>
